import React from 'react';
import './Progress.css';


const Progress = ({ message, subtext, size = 40 }) => {

    const spinnerStyle = {
        width: size + 'px',
        height: size + 'px'
    };

    return (
        <div className="progress-container" role='status' aria-live='polite'>
            <div className="progress-spinner" style={spinnerStyle}>
            </div>
            {message && <p className="progress-message">
                {message}
            </p>}
            {subtext && <span className="progress-subtext">
                {subtext}
            </span>}
        </div>
    );
};

export default Progress;